import React, { createContext, useCallback, useContext, useState } from 'react';
import axios from 'axios';

const QuestContext = createContext(null);

const countDailyActive = (daily) => {
  if (!daily?.available || daily.claimed) return 0;
  return 1;
};

export const QuestProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeCount, setActiveCount] = useState(0);
  const [quests, setQuests] = useState([]);
  const [dailyQuest, setDailyQuest] = useState(null);
  const [story, setStoryView] = useState(null);
  const [storyCount, setStoryCount] = useState(0);
  const [otherCount, setOtherCount] = useState(0);
  const [loading, setLoading] = useState(false);

  // Hikâye paneli bir işlem yaptığında görünümü ve düğmedeki rozeti günceller.
  const setStory = useCallback((view, actionCount) => {
    setStoryView(view || null);
    const n = Number(actionCount) || 0;
    setStoryCount(n);
    setActiveCount(otherCount + n);
  }, [otherCount]);

  // openTab: panel açılırken seçilecek sekme (ör. 'level' = ödüllü video kartının olduğu sekme).
  const [openTab, setOpenTab] = useState(null);
  const openQuests = useCallback((tab) => {
    setOpenTab(typeof tab === 'string' ? tab : null);
    setIsOpen(true);
  }, []);
  const closeQuests = useCallback(() => setIsOpen(false), []);

  const refreshQuests = useCallback(async (username) => {
    if (!username) return;
    setLoading(true);
    try {
      const storyReq = axios
        .get(`/api/story/status?username=${encodeURIComponent(username)}`)
        .catch(() => null);
      const [levelRes, dailyRes] = await Promise.all([
        axios.get(`/api/level-quests/status?username=${encodeURIComponent(username)}`),
        axios.get(`/api/daily-quests/status?username=${encodeURIComponent(username)}`)
      ]);
      const storyRes = await storyReq;
      let storyActive = 0;
      if (storyRes?.data?.success) {
        setStoryView(storyRes.data.story || null);
        storyActive = Number(storyRes.data.actionCount) || 0;
        setStoryCount(storyActive);
      }
      let levelActive = 0;
      if (levelRes.data?.success) {
        setQuests(Array.isArray(levelRes.data.quests) ? levelRes.data.quests : []);
        levelActive = Number(levelRes.data.activeCount) || 0;
      }
      let dailyActive = 0;
      if (dailyRes.data?.success && dailyRes.data.dailyQuest) {
        setDailyQuest(dailyRes.data.dailyQuest);
        dailyActive = countDailyActive(dailyRes.data.dailyQuest);
      } else {
        setDailyQuest(null);
      }
      setOtherCount(levelActive + dailyActive);
      setActiveCount(levelActive + dailyActive + storyActive);
    } catch {
      /* ignore */
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <QuestContext.Provider
      value={{
        isOpen,
        openQuests,
        openTab,
        closeQuests,
        activeCount,
        setActiveCount,
        quests,
        setQuests,
        dailyQuest,
        setDailyQuest,
        story,
        storyCount,
        setStory,
        loading,
        refreshQuests
      }}
    >
      {children}
    </QuestContext.Provider>
  );
};

export const useQuests = () => {
  const ctx = useContext(QuestContext);
  if (!ctx) {
    throw new Error('useQuests must be used within QuestProvider');
  }
  return ctx;
};
